export enum KestrelInspectionType {
  DEFAULT = 'default',
  ROOFTOP = 'rooftop',
  NAVY = 'navy',
  NAVY_MULTI_LAYER = 'navy-multi-layer',
  NAVMAN = 'navman',
  G1N6 = 'g1n6',
  SITEVIEW = 'siteview',
  AEROSPACE = 'aerospace',
  THREE_D_SEGMENTATION = 'three-d-segmentation',
  VIRTUAL_REPORT = 'virtual-report',
}
